import React, { useEffect, useState, useContext, PropsWithChildren } from 'react';
import { loadSpace, InitOptions } from '@usersnap/browser';

export type UsersnapApi = Awaited<ReturnType<typeof loadSpace>>;

type UsernapProviderProps = {
    apiKey: string;
    init?: InitOptions;
} & PropsWithChildren;

const notInitializedHandler = async () => {
    throw new Error("Usernap hasn't been initialized yet");
};

const DEFAULT_API: UsersnapApi = {
    init: notInitializedHandler,
    logEvent: notInitializedHandler,
    show: notInitializedHandler,
    hide: notInitializedHandler,
    destroy: notInitializedHandler,
    on: notInitializedHandler,
    off: notInitializedHandler,
};

export const UsersnapContext = React.createContext<UsersnapApi>(DEFAULT_API);

export const UsersnapProvider: React.FunctionComponent<UsernapProviderProps> = ({ apiKey, init, children }) => {
    const [usersnapApi, setUsersnapApi] = useState<UsersnapApi>(DEFAULT_API);

    useEffect(() => {
        loadSpace(apiKey).then((api) => {
            api.init(init);
            setUsersnapApi(api);
        });
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [init]);

    return <UsersnapContext.Provider value={usersnapApi}>{children}</UsersnapContext.Provider>;
};

export function useUsersnap() {
    return useContext(UsersnapContext);
}
